import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Home from './Home';
import Aura from './pages/Aura';
import Portfolio from './pages/Portfolio';
import WorkArticle from './pages/WorkArticle';
import Contact from './pages/Contact';
import AuraPromoSticker from './components/layout/AuraPromoSticker';

const AppSub = () => {
  return (
    <Router>
        <Routes>
            <Route path='/' element={<Home />} />
            <Route path='/about' element={<Navigate to="/" replace />} />
            <Route path='/aura' element={<Aura />} />
            <Route path='/artelligence' element={<Navigate to="/aura" replace />} />
            <Route path='/work/:workId' element={<WorkArticle />} />
            <Route path='/work' element={<Portfolio />} />
            <Route path='/portfolio' element={<Navigate to="/work" replace />} />
            <Route path='/contact' element={<Contact />} />
        </Routes>
        <AuraPromoSticker />
    </Router>
  )
}

export default AppSub